<template>
  <!--    col-md-4-->
  <div
    class="sidebar-container"
    :class="[
      checkMobileStatus ? 'mobile-view' : 'web-view',
      schoolID === 'SCH201400000471' ||
      schoolID === 'SCH201400000480' ||
      schoolID === 'SCH201400000497' ||
      schoolID === 'SCH201400000501' ||
      schoolID === 'SCH201400000510' ||
      schoolID === 'SCH201500000032' ||
      schoolID === 'SCH201500000054' ||
      schoolID === 'SCH201500000074' ||
      schoolID === 'SCH201400000541' ||
      schoolID === 'SCH201400000553' ||
      (isParent === 'Parent' && parentSchIds.includes('SCH201400000480'))
        ? 'col-md-4'
        : 'col-md-1',
    ]"
  >
    <div class="sidebar-list-container">
      <div
        class="each-sidebar"
        v-for="(item, index) in sidebarList"
        :key="index"
        v-bind:class="item.name === defaultSidebarName ? 'active' : ''"
        v-if="item.linkto"
      >
        <a class="w3-bar-item w3-button" v-on:click.stop="changeSidebar($event, item.linkto, item.iconName)" v-bind:id="item.name">
          <span class="sidebar-icon"><i :class="item.iconName" class="fa fa-2x sidebar-logo" aria-hidden="true"></i></span>
          <label class="sidebar-label">{{ item.name }}</label>
        </a>
      </div>
    </div>

    <div
      class="sidebar-action-container"
      v-if="
        schoolID === 'SCH201400000471' ||
        schoolID === 'SCH201400000480' ||
        schoolID === 'SCH201400000497' ||
        schoolID === 'SCH201400000501' ||
        schoolID === 'SCH201400000510' ||
        schoolID === 'SCH201500000032' ||
        schoolID === 'SCH201500000054' ||
        schoolID === 'SCH201500000074' ||
        schoolID === 'SCH201400000541' ||
        schoolID === 'SCH201400000553' ||
        (isParent === 'Parent' && parentSchIds.includes('SCH201400000480'))
      "
    >
      <div v-if="checkMobileStatus" @click="showNotificationList()" class="mobile-notif-icon">
        <span><i class="fa fa-bell-o fa-2x" aria-hidden="true"></i></span>
        <span class="notif-count" v-if="totalUnread > 0">{{ totalUnread }}</span>
      </div>

      <div class="notif-container">
        <div class="empty-notification-container" v-if="arrobj_notificationList.length <= 0">
          <span>{{ notif_empty_message }}</span>
          <img src="../assets/notfound.png" />
        </div>

        <div class="notification-list-container" v-show="arrobj_notificationList.length > 0">
          <h5>
            <span><i class="fa fa-bell-o" aria-hidden="true" style="color: #426dff"></i></span> {{ lang('Notifications') }}
          </h5>

          <hr />

          <div class="notification-list-content">
            <div class="notification-list">
              <div
                class="each-notification-container"
                v-for="(notifList, index) of arrobj_notificationList"
                :class="notifList.NotiRead === 'No' ? 'unread' : 'read'"
                @click="notifList.NotiRead === 'No' ? updateNotifStatus(notifList, index) : accessToRelatedPage(notifList)"
              >
                <div class="left-notification-container">
                  <img
                    class="notif-img"
                    src="../assets/boy.png"
                    v-if="notifList.CreatedByProfileImage === '' || notifList.CreatedByProfileImage === undefined"
                  />
                  <img
                    class="notif-img"
                    :src="`data:image/jpg;base64, ${notifList.CreatedByProfileImage}`"
                    v-if="notifList.CreatedByProfileImage !== '' && notifList.CreatedByProfileImage !== undefined"
                  />
                </div>

                <div class="right-notification-container">
                  <div class="each-notif-content">
                    <label>{{ notifList.CreatedByName }}</label>
                    <small class="date">{{ notifList.NotiCreatedOn_converted }}</small>

                    <span v-if="notifList.NotiType === 'Update'">{{ postFeedMsg }}</span>
                    <span v-if="notifList.NotiType === 'FeedComment'">{{ postCommentFeedMsg }}</span>
                    <span v-if="notifList.NotiType === 'Broadcast'">{{ postBroadcastMsg }}</span>
                    <span v-if="notifList.NotiType === 'Portfolio'">{{ postPortfolioMsg }}</span>
                  </div>
                </div>

                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import $j from 'jquery'
import DataSource from '../data/datasource'
import { lang } from '../locale/index'
// import ProfileImg from "../assets/boy.png";
import moment from 'moment'

import { NotifEvent, notifGlobalVariable } from '../global/index.js'

export default {
  name: 'Sidebar',
  components: {},
  data() {
    return {
      sidebarList: [],
      array_postID: [],

      loading: true,
      defaultSidebarName: '',
      sidebarIcon: '',
      isParent: '',
      changedLink: '',

      scrollPosition: null,

      arrobj_notificationList: [],
      notificationID: '',
      limit: 10,
      notif_empty_message: lang('Notif Empty Message'),
      postFeedMsg: lang('Post Feed Msg'),
      postCommentFeedMsg: lang('Post Comment Feed Msg'),
      postBroadcastMsg: lang('Post Broadcast Msg'),
      postPortfolioMsg: lang('Post Portfolio Msg'),
      notifAction: 'MarkAsRead',
      interNotif: '',

      checkMobileStatus: false,
      totalUnread: 0,
      schoolID: '',
      parentSchIds: [],
      numOfDays: '14',
    }
  },
  methods: {
    lang,
    changeSidebar: function (event, linkto, iconName) {
      event.preventDefault
      this.$set(notifGlobalVariable, 'NotiValue', '')

      window.history.scrollRestoration = 'manual'

      if (this.defaultSidebarName != event.currentTarget.id) {
        this.defaultSidebarName = event.currentTarget.id
        this.sidebarIcon = iconName

        this.$router.push('/' + linkto)
        // window.location.href = linkto;
      } else {
        // this.$router.push('/newfeed').catch(err => {});
        // this.$emit("notificationType", "");
        this.$root.$emit('notificationType', '')
      }
    },
    async getNotificationList() {
      this.totalUnread = 0

      try {
        this.arrobj_notificationList = []
        this.notificationID = ''

        const notificationList = await DataSource.shared.getNotificationsByRowNumber(this.notificationID, this.limit, this.numOfDays)

        if (notificationList.Table) {
          // console.log(notificationList.Table, "");

          notificationList.Table.forEach((object, index) => {
            if (index === notificationList.Table.length - 1) {
              this.notificationID = object.NotiID
            }

            if (object.NotiRead.toLowerCase() === 'no') {
              this.totalUnread = this.totalUnread + 1
            }

            object.NotiCreatedOn_converted = moment(String(object.NotiCreatedOn)).format('MM/DD/YYYY')
          })

          var filteredNotificationList = notificationList.Table.filter(function (el) {
            if (el.NotiType !== 'Portfolio') {
              return el
            }
          })

          // this.arrobj_notificationList = notificationList.Table;
          this.arrobj_notificationList = filteredNotificationList
        }
      } catch (e) {
        this.result = e
      }
    },
    async loadmoreNotificationList() {
      try {
        const notificationList = await DataSource.shared.getNotificationsByRowNumber(this.notificationID, this.limit, this.numOfDays)

        if (notificationList.Table) {
          notificationList.Table.forEach((object, index) => {
            if (index === notificationList.Table.length - 1) {
              this.notificationID = object.NotiID
            }

            if (object.NotiRead.toLowerCase() === 'no') {
              this.totalUnread = this.totalUnread + 1
            }

            object.NotiCreatedOn_converted = moment(String(object.NotiCreatedOn)).format('MM/DD/YYYY')
          })

          var filteredNotificationList = notificationList.Table.filter(function (el) {
            if (el.NotiType !== 'Portfolio') {
              return el
            }
          })

          // this.arrobj_notificationList.push.apply(this.arrobj_notificationList, notificationList.Table);
          this.arrobj_notificationList.push.apply(this.arrobj_notificationList, filteredNotificationList)
        }
      } catch (e) {
        this.result = e
      }
    },
    async updateNotifStatus(notif, notifIndex) {
      const updatedNotifStatus = await DataSource.shared.updateNotificationsStatus(notif.NotiID, this.notifAction)

      if (updatedNotifStatus.code === '1') {
        this.$set(this.arrobj_notificationList[notifIndex], 'NotiRead', 'Yes')

        this.totalUnread = this.totalUnread - 1
      } else {
        console.log(updatedNotifStatus.code)
      }

      this.accessToRelatedPage(notif)
    },
    async accessToRelatedPage(notif) {
      this.showNotificationList()
      this.$set(notifGlobalVariable, 'NotiValue', '')
      this.$set(notifGlobalVariable, 'NotiType', '')
      this.$set(notifGlobalVariable, 'NotiValue', notif.NotiValue)
      this.$set(notifGlobalVariable, 'NotiType', notif.NotiType)

      this.$root.$emit('notificationType', notif)

      if (notif.NotiType === 'Update') {
        this.$router.push('/newfeed').catch(err => {})
      } else if (notif.NotiType === 'FeedComment') {
        this.$router.push('/newfeed').catch(err => {})
      } else if (notif.NotiType === 'Broadcast') {
        this.$router.push('/newbroadcast').catch(err => {})
      }
    },

    connectServer() {
      var $this = this
      var conn = $.hubConnection(process.env.VUE_APP_ROOT_API, { qs: 'clientId=1232222' })
      $this.proxy = conn.createHubProxy('PostingHub')
      conn.start({ jsonp: true })
      $this.getMsg()
    },
    sendMsg() {
      var $this = this
      $this.proxy.invoke('SendNotification').done(msg => {})
    },
    getMsg() {
      var $this = this

      $this.proxy.on('notificationMessage', () => {
        this.getNotificationList()
      })
    },

    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
        // return true;
      } else {
        this.checkMobileStatus = false
        // return false;
      }
    },

    showNotificationList() {
      // console.log($j(".mobile-notification-list-content").css("display"), "wakakak");
      if ($j('.mobile-view .notif-container').css('display') === 'block') {
        $j('.mobile-view .notif-container').hide()
      } else {
        $j('.mobile-view .notif-container').show()
      }
    },
  },
  mounted() {
    this.totalUnread = 0

    const self = this

    let sidebarName = ''
    let sidebarIcon = ''

    self.getNotificationList()

    self.connectServer()
    self.isMobile()

    $j(document).ready(function () {
      // var otherHeight = (window.outerHeight - ($j('.topbar')[0].offsetHeight + $j('.menu-box-wrap')[0].offsetHeight));
      //
      // $(".sidebar-list-container").css("height", (otherHeight - 120) );

      if (Cookies.get('userTypeSession') === 'Parent') {
        $j(document).bind('contextmenu', function (e) {
          return false
        })
      }

      $j('.notification-list-content').scroll(function () {
        let $this = $j(this)

        const listElm = document.querySelector('.notification-list-content')
        // if (scrollPercent >= 80) {
        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          if (self.arrobj_notificationList.length % 10 === 0) {
            self.loadmoreNotificationList()
          }
        }
      })
    })

    // $j("#mobile-notification-list-content").focusout(function() {
    //     console.log("hahaha");
    //     $j(".mobile-notification-list-content").hide();
    // });

    // $j(document).mouseup(function(e){
    //     var container = $j("#mobile-notification-list-content");
    //
    //     // If the target of the click isn't the container
    //     if(!container.is(e.target) && container.has(e.target).length === 0){
    //         console.log("hahaha");
    //         $j(".mobile-notification-list-content").hide();
    //         container.hide();
    //     }
    // });

    if (this.$router.currentRoute.fullPath === '/') {
      if (Cookies.get('userTypeSession') === 'Parent') {
        sidebarName = lang('Travel Declaration')
        sidebarIcon = 'fa-plane'
      } else {
        sidebarName = lang('Feed')
        sidebarIcon = 'fa-align-justify'
      }
    }

    if (this.$router.currentRoute.fullPath.toLowerCase() === '/newfeed') {
      sidebarName = lang('Feed')
      sidebarIcon = 'fa-align-justify'
    } else if (this.$router.currentRoute.fullPath.toLowerCase() === '/newmedia') {
      // sidebarName = "Media";
      sidebarName = lang('Gallery')
      sidebarIcon = 'fa-picture-o'
    } else if (this.$router.currentRoute.fullPath.toLowerCase() === '/newbroadcast') {
      // sidebarName = "Broadcast";
      sidebarName = lang('Broadcast')
      sidebarIcon = 'fa-bullhorn' // fa-bell-o
    } else if (this.$router.currentRoute.fullPath.toLowerCase() === '/newevent') {
      // sidebarName = "Event";
      sidebarName = lang('Event')
      sidebarIcon = 'fa-calendar-o'
    } else if (this.$router.currentRoute.fullPath.toLowerCase() === '/newstudentinfo') {
      // sidebarName = "Student";
      sidebarName = lang('Student')
      sidebarIcon = 'fa-user-circle-o'
    } else if (this.$router.currentRoute.fullPath.toLowerCase() === '/newinvoice') {
      // sidebarName = "Invoice";
      sidebarName = lang('Invoice')
      sidebarIcon = 'fa-files-o'
    } else if (this.$router.currentRoute.fullPath.toLowerCase() === '/traveldeclaration') {
      sidebarName = lang('Travel Declaration')
      sidebarIcon = 'fa-plane'
    } else if (this.$router.currentRoute.fullPath.toLowerCase() === '/plannerassignstudent') {
      sidebarName = 'Planner'
      sidebarIcon = 'fa-clipboard'
    } else if (this.$router.currentRoute.fullPath.toLowerCase() === '/portfolio') {
      sidebarName = lang('Learning Journeys')
      sidebarIcon = 'fa-leanpub'
    }

    this.defaultSidebarName = sidebarName
    this.sidebarIcon = sidebarIcon

    this.isParent = Cookies.get('userTypeSession')
    this.schoolID = ''
    this.schoolID = Cookies.get('schoolSession')

    if (this.isParent === 'Parent') {
      this.schoolIDs = JSON.parse(this.schoolID)
      this.schoolIDs = this.schoolIDs.Table

      let arr_SchIDs = []
      this.parentSchIds = []
      this.schoolIDs.forEach((object, index) => {
        arr_SchIDs.push(object.SCH_Ids)
        this.parentSchIds.push(object.SCH_Ids)
      })

      if (arr_SchIDs.includes('SCH201400000480')) {
        this.sidebarList = [
          { name: lang('Travel Declaration'), iconName: 'fa-plane', linkto: 'traveldeclaration' },
          { name: lang('Broadcast'), iconName: 'fa-bullhorn', linkto: 'newbroadcast' },
          { name: lang('Event'), iconName: 'fa-calendar-o', linkto: 'newevent' },
          { name: lang('Feed'), iconName: 'fa-align-justify', linkto: 'newfeed' },
        ]
      } else {
        this.sidebarList = [
          { name: lang('Travel Declaration'), iconName: 'fa-plane', linkto: 'traveldeclaration' },
          { name: lang('Event'), iconName: 'fa-calendar-o', linkto: 'newevent' },
        ]
      }

      // this.sidebarList = [
      //     {"name":lang("Broadcast"), "iconName": "fa-bullhorn", "linkto": "newbroadcast"},
      //     {"name":lang("Feed"), "iconName": "fa-align-justify", "linkto": "newfeed"},
      //     {"name":lang("Event"), "iconName": "fa-calendar-o", "linkto": "newevent"},
      //     {"name":lang("Student"), "iconName": "fa-user-circle-o", "linkto": "newstudentinfo"},
      //     {"name":lang("Invoice"), "iconName": "fa-files-o", "linkto": "newinvoice"}];
    } else {
      // ecda school + cm+718
      if (
        this.schoolID === 'SCH201400000471' ||
        this.schoolID === 'SCH201400000480' ||
        this.schoolID === 'SCH201400000497' ||
        this.schoolID === 'SCH201400000501' ||
        this.schoolID === 'SCH201400000510' ||
        this.schoolID === 'SCH201500000032' ||
        this.schoolID === 'SCH201500000054' ||
        this.schoolID === 'SCH201500000074' ||
        this.schoolID === 'SCH201400000541' ||
        this.schoolID === 'SCH201400000553'
      ) {
        this.sidebarList = [
          { name: lang('Broadcast'), iconName: 'fa-bullhorn', linkto: 'newbroadcast' },
          { name: lang('Feed'), iconName: 'fa-align-justify', linkto: 'newfeed' },
          { name: lang('Event'), iconName: 'fa-calendar-o', linkto: 'newevent' },
          { name: lang('Gallery'), iconName: 'fa-picture-o', linkto: 'newmedia' },
          { name: 'Planner', iconName: 'fa-clipboard', linkto: 'plannerassignstudent' },
          { name: lang('Learning Journeys'), iconName: 'fa-leanpub', linkto: 'portfolio' },
        ]
      } else {
        this.sidebarList = [{ name: lang('Event'), iconName: 'fa-calendar-o', linkto: 'newevent' }]
      }

      // this.sidebarList = [
      //     {"name":lang("Broadcast"), "iconName": "fa-bullhorn", "linkto": "newbroadcast"},
      //     {"name":lang("Feed"), "iconName": "fa-align-justify", "linkto": "newfeed"},
      //     {"name":lang("Event"), "iconName": "fa-calendar-o", "linkto": "newevent"},
      //     {"name":lang("Gallery"), "iconName": "fa-picture-o", "linkto": "newmedia"}];
    }
  },
  created() {
    window.addEventListener('resize', this.isMobile)
    // this.handleResize();
  },
  destroyed() {
    $j('.notification-list-content').unbind('scroll')
    window.removeEventListener('resize', this.isMobile)
  },
  watch: {
    isChange: function (newVal, oldVal) {
      // watch it
      // console.log(newVal, "new");
      // console.log(oldVal, "old");

      // this.getNotificationList();
      if (newVal && newVal !== oldVal) {
        // this.getNotificationList();
        this.sendMsg()
      }
      // console.log('Prop changed: ', newVal, ' | was: ', oldVal);
    },
  },
  props: ['isChange'],
}
</script>

<style scoped>
/*#Web Css */
.web-view.sidebar-container {
  padding: 0px;
  display: inline-block;
  vertical-align: top;
  text-align: left;
  position: sticky;
  top: 0px;
  height: calc(100vh - 40px);
}

.web-view .sidebar-list-container {
  display: inline-block;
  text-align: center;
  width: 100px;
  padding: 20px 0px;
  height: 100%;
}

.web-view .each-sidebar {
  margin-bottom: 25px;
}

.web-view .sidebar-action-container {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 100px);
  height: 100%;
}

.web-view .notif-container {
  height: 100%;
  display: block !important;
  background: white;
}

.web-view .empty-notification-container {
  text-align: center;
}

.web-view .empty-notification-container > span {
  display: block;
}

.web-view .notification-list-container {
  padding: 10px;
  background: white;
  height: 100%;
  overflow: auto;
}

/* Mobile Css */
.mobile-view.sidebar-container {
  max-width: 100%;
}

.mobile-view .sidebar-list-container {
  text-align: center;
  padding: 20px 0px;
  height: 100%;
}

.mobile-view .each-sidebar {
  text-align: center;
  display: inline-block;
  margin-right: 15px;
}

.mobile-view .notif-container {
  position: absolute;
  background: white;
  width: 85%;
  left: 8%;
  padding: 5px;
  top: 25px;
  margin: 0px auto;
  overflow: auto;
  border: 1px solid #ccc;
  display: none;
  z-index: 99;
  max-height: 320px;
}

.mobile-view .mobile-notif-icon {
  position: absolute;
  right: 10px;
  top: -15px;
  background: #edf0f4;
  padding: 5px;
  border-radius: 50%;
}

.mobile-view .notif-count {
  position: absolute;
  display: block;
  background: red;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: white;
  top: -10px;
  right: -6px;
}

/* Multiple platform Css */
.each-sidebar,
.sidebar-label {
  cursor: pointer;
}

.each-sidebar.active .sidebar-label,
.each-sidebar.active .sidebar-icon {
  color: #426dff;
}

.sidebar-icon {
  display: block;
}

.sidebar-label {
  display: unset !important;
  font-weight: normal;
}

.sidebar-icon,
.sidebar-label {
  color: #91a3b6;
}

.left-notification-container {
  display: inline-block;
}

.right-notification-container {
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  max-width: calc(100% - 60px);
  text-align: left;
  width: 100%;
}

.notif-img {
  border-radius: 50%;
  height: 40px;
  width: 40px;
  max-width: none;
}

.each-notification-container {
  cursor: pointer;
}

.each-notification-container.unread {
  opacity: 1;
  background: #ccc;
  border-radius: 12px;
}

.each-notification-container.read {
  opacity: 0.8;
}

.each-notif-content {
  display: inline-block;
  font-size: 12px;
  width: 100%;
}

.each-notif-content > label {
  margin: 0px;
  /*font-weight: normal;*/
  display: inline-block !important;
  max-width: calc(100% - 60px);
}

.each-notif-content > small {
  display: inline-block;
  float: right;
}

.each-notif-content > span {
  display: block;
}
</style>

<style>
#main-content {
  overflow-x: unset !important;
}

.topbar {
  margin-right: 0px !important;
}

/*@media (max-width: 450px) {*/
/*    #main-content {*/
/*        overflow: unset!important;*/
/*    }*/

/*    .topbar {*/
/*        margin-right: 0px!important;*/
/*    }*/
/*}*/

/*@media (max-width: 769px) {*/
/*    #main-content {*/
/*        overflow: unset!important;*/
/*    }*/

/*    .topbar {*/
/*        margin-right: 0px!important;*/
/*    }*/
/*}*/
</style>
